// import React, { useEffect, useRef, useState } from "react";
// import '../pages/Summary.css'
// import Layout from "./Layout";
// import { Link, useLocation } from "react-router-dom";

// function Summary({ username, onSignOut }) {
//     const [selectedRows, setSelectedRows] = useState([]);
//     const menuRef = useRef(null);
//     const rows = [
//         { id: 1, createdDate: '1/5/2025', category: 'Mechanical Part', subcategory: 'Chamber Body', bu: 'BU2', buCountry: 'United States', supplier: 'Supplier J', partId: 'PID_2222', partDescription: 'Kraft Box​', annualSpend: '4.8M', supplierPrice: '34.3K', shouldCostPrice: '24.7K', potentialSavingsinDoller: '1.3M', potentialSavingsinPercentage: '28', negotiatonStatus: 'Successful', negotiationPrice: '29.8K', savingsRealized: '0.6M' },
//         { id: 2, createdDate: '1/6/2025', category: 'Paper Packaging', subcategory: 'Corrugated Cartons', bu: 'BU8', buCountry: 'United States', supplier: 'Supplier II', partId: 'PID_3333​', partDescription: 'Shrink on Shrink​', annualSpend: '3.1M', supplierPrice: '0.3K', shouldCostPrice: '0.45', potentialSavingsinDoller: '0.5M', potentialSavingsinPercentage: '15', negotiatonStatus: 'Deferred', negotiationPrice: '', savingsRealized: '' },
//         { id: 3, createdDate: '1/7/2025', category: 'Flexible Packaging', subcategory: 'Shrink Wrap', bu: 'BU1', buCountry: 'Canada', supplier: 'Supplier X', partId: 'PID_4333​', partDescription: '3-core Copper Conductor', annualSpend: '2.0M', supplierPrice: '0.71K', shouldCostPrice: '0.4', potentialSavingsinDoller: '0', potentialSavingsinPercentage: '', negotiatonStatus: 'Out of Scope', negotiationPrice: '', savingsRealized: '' }
//     ];

//     const allSelected = selectedRows.length === rows.length;

//     const toggleSelectAll = () => {
//         if (allSelected) {
//             setSelectedRows([]);
//         } else {
//             setSelectedRows(rows.map((row) => row.id));
//         }
//     };

//     const toggleRow = (id) => {
//         setSelectedRows((prev) =>
//             prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
//         );
//     };
//     const [menuOpenRow, setMenuOpenRow] = useState(null);
//     const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

//     const toggleMenu = (id) => {
//         setMenuOpenRow((prev) => (prev === id ? null : id));
//     };
//     useEffect(() => {
//         function handleClickOutside(event) {
//             if (menuRef.current && !menuRef.current.contains(event.target)) {
//                 setMenuOpenRow(null);
//             }
//         }
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, []);

//     const location = useLocation();
//     const activities = location.state?.activities || [];
//     console.log(activities)
//     return (
//         <Layout username={username} onSignOut={onSignOut}>
//             <div className="">
//                 <div className="SummaryBreadCrumb border-b-[1px] border-[#CFCFCF] gap-2">
//                     <Link to="/">
//                         <span className="SummaryBreadCrumbInside cursor-pointer hover:text-black">
//                             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
//                                 <path d="M8.33464 17.4538V12.4538H11.668V17.4538H15.8346V10.7871H18.3346L10.0013 3.28711L1.66797 10.7871H4.16797V17.4538H8.33464Z" />
//                             </svg>
//                             <span className="SummaryText">Home</span>
//                         </span>
//                     </Link>
//                     <span>/</span>
//                     <span className="HomeText">Your Activities</span>
//                 </div>
//                 <div className="flex flex-col items-center justify-center h-[70vh] text-center gap-1">
//                     <div className="pb-3">
//                         <svg xmlns="http://www.w3.org/2000/svg" width="84" height="92" viewBox="0 0 84 92" fill="none">
//                             <path opacity="0.3" d="M29.6654 64.7506C29.6654 49.834 41.832 37.6673 56.7487 37.6673C60.457 37.6673 63.957 38.4173 67.1654 39.7507V16.834H58.832V29.334H17.1654V16.834H8.83203V75.1673H31.7487C30.4154 71.959 29.6654 68.459 29.6654 64.7506Z" fill="#A100FF" />
//                             <path d="M31.75 75.167H8.83333V16.8337H17.1667V29.3337H58.8333V16.8337H67.1667V39.7503C70.2917 41.042 73.0833 42.917 75.5 45.2503V16.8337C75.5 12.2503 71.75 8.50033 67.1667 8.50033H49.75C48 3.66699 43.4167 0.166992 38 0.166992C32.5833 0.166992 28 3.66699 26.25 8.50033H8.83333C4.25 8.50033 0.5 12.2503 0.5 16.8337V75.167C0.5 79.7503 4.25 83.5003 8.83333 83.5003H37.25C34.9583 81.0837 33.0417 78.292 31.75 75.167ZM38 8.50033C40.2917 8.50033 42.1667 10.3753 42.1667 12.667C42.1667 14.9587 40.2917 16.8337 38 16.8337C35.7083 16.8337 33.8333 14.9587 33.8333 12.667C33.8333 10.3753 35.7083 8.50033 38 8.50033Z" fill="#A100FF" />
//                             <path d="M72.5833 74.75C74.25 71.8333 75.5 68.5 75.5 64.75C75.5 54.3333 67.1667 46 56.75 46C46.3333 46 38 54.3333 38 64.75C38 75.1667 46.3333 83.5 56.75 83.5C60.5 83.5 63.8333 82.25 66.75 80.5833L78 91.8333L83.8333 86L72.5833 74.75ZM56.75 75.1667C50.9167 75.1667 46.3333 70.5833 46.3333 64.75C46.3333 58.9167 50.9167 54.3333 56.75 54.3333C62.5833 54.3333 67.1667 58.9167 67.1667 64.75C67.1667 70.5833 62.5833 75.1667 56.75 75.1667Z" fill="#A100FF" />
//                         </svg>
//                     </div>
//                     <span className="TextNoActivity">
//                         <span>No Recent Activities to display</span>
//                     </span>
//                     <span className="TextNoActivity pb-4">
//                         Create a new should cost report with our should cost calculator
//                     </span>
//                     <Link to="/LandingPage">
//                         <span className="SummaryButton cursor-pointer hover:bg-[#7500C0]">
//                             <span className="SummaryButtonText">Should Cost Calculator</span>
//                         </span>
//                     </Link>
//                 </div>
//             </div>

//         </Layout>
//     );
// }
// export default Summary;

import React, { useEffect, useRef, useState } from "react";
import "../pages/Summary.css";
import Layout from "./Layout";
import { Link, useLocation } from "react-router-dom";

function Summary({ username, onSignOut }) {
    const menuRef = useRef(null);
    const [menuOpenRow, setMenuOpenRow] = useState(null);

    const location = useLocation();
    const activities = location.state?.activities || [];

    const filteredKeys = (obj) =>
        Object.keys(obj).filter((key) => typeof obj[key] !== "object");

    return (
        <Layout username={username} onSignOut={onSignOut}>
            <div className="">
                <div className="SummaryBreadCrumb border-b-[1px] border-[#CFCFCF] gap-2">
                    <Link to="/">
                        <span className="SummaryBreadCrumbInside cursor-pointer hover:text-black">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path d="M8.33464 17.4538V12.4538H11.668V17.4538H15.8346V10.7871H18.3346L10.0013 3.28711L1.66797 10.7871H4.16797V17.4538H8.33464Z" />
                            </svg>
                            <span className="SummaryText">Home</span>
                        </span>
                    </Link>
                    <span>/</span>
                    <span className="HomeText">Your Activities</span>
                </div>

                {activities.length > 0 ? (
                    <div className="overflow-x-auto p-4">
                        <table className="min-w-full border !border-gray-300 bg-white shadow-md rounded-lg">
                            <thead className="bg-[#E6DCFF]">
                                <tr>
                                    {filteredKeys(activities[0]).map((key) => (
                                        <th key={key} className="!px-3 py-2 !border-b text-[13px]">
                                            {key}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((item, index) => (
                                    <tr key={index} className="hover:bg-[#f4f3ff]">
                                        {filteredKeys(item).map((key) => {
                                            const value =
                                                item[key] !== null && item[key] !== undefined
                                                    ? item[key].toString()
                                                    : "-";

                                            // Conditional color for Negotiation_Status column
                                            const isNegotiationStatus = key.toLowerCase().includes("negotiation_status");
                                            const textColorClass =
                                                isNegotiationStatus && value.toLowerCase() === "successful"
                                                    ? "text-green-600 font-medium"
                                                    : isNegotiationStatus
                                                        ? "text-orange-500 font-medium"
                                                        : "";

                                            return (
                                                <td
                                                    key={key}
                                                    className={`!px-4 py-2 text-[13px] !border-b ${textColorClass}`}
                                                >
                                                    {value}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center h-[70vh] text-center gap-1">
                        <div className="pb-3">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="84"
                                height="92"
                                viewBox="0 0 84 92"
                                fill="none"
                            >
                                <path
                                    opacity="0.3"
                                    d="M29.6654 64.7506C29.6654 49.834 41.832 37.6673 56.7487 37.6673C60.457 37.6673 63.957 38.4173 67.1654 39.7507V16.834H58.832V29.334H17.1654V16.834H8.83203V75.1673H31.7487C30.4154 71.959 29.6654 68.459 29.6654 64.7506Z"
                                    fill="#A100FF"
                                />
                                <path
                                    d="M31.75 75.167H8.83333V16.8337H17.1667V29.3337H58.8333V16.8337H67.1667V39.7503C70.2917 41.042 73.0833 42.917 75.5 45.2503V16.8337C75.5 12.2503 71.75 8.50033 67.1667 8.50033H49.75C48 3.66699 43.4167 0.166992 38 0.166992C32.5833 0.166992 28 3.66699 26.25 8.50033H8.83333C4.25 8.50033 0.5 12.2503 0.5 16.8337V75.167C0.5 79.7503 4.25 83.5003 8.83333 83.5003H37.25C34.9583 81.0837 33.0417 78.292 31.75 75.167ZM38 8.50033C40.2917 8.50033 42.1667 10.3753 42.1667 12.667C42.1667 14.9587 40.2917 16.8337 38 16.8337C35.7083 16.8337 33.8333 14.9587 33.8333 12.667C33.8333 10.3753 35.7083 8.50033 38 8.50033Z"
                                    fill="#A100FF"
                                />
                                <path
                                    d="M72.5833 74.75C74.25 71.8333 75.5 68.5 75.5 64.75C75.5 54.3333 67.1667 46 56.75 46C46.3333 46 38 54.3333 38 64.75C38 75.1667 46.3333 83.5 56.75 83.5C60.5 83.5 63.8333 82.25 66.75 80.5833L78 91.8333L83.8333 86L72.5833 74.75ZM56.75 75.1667C50.9167 75.1667 46.3333 70.5833 46.3333 64.75C46.3333 58.9167 50.9167 54.3333 56.75 54.3333C62.5833 54.3333 67.1667 58.9167 67.1667 64.75C67.1667 70.5833 62.5833 75.1667 56.75 75.1667Z"
                                    fill="#A100FF"
                                />
                            </svg>
                        </div>
                        <span className="TextNoActivity">
                            <span>No Recent Activities to display</span>
                        </span>
                        <span className="TextNoActivity pb-4">
                            Create a new should cost report with our should cost calculator
                        </span>
                        <Link to="/LandingPage">
                            <span className="SummaryButton cursor-pointer hover:bg-[#7500C0]">
                                <span className="SummaryButtonText">
                                    Should Cost Calculator
                                </span>
                            </span>
                        </Link>
                    </div>
                )}
            </div>
        </Layout>
    );
}

export default Summary;
